var map = {
	"./en.js": [
		7393,
		393
	],
	"./full_en.js": [
		8909,
		909
	],
	"./full_es.js": [
		9162,
		162
	],
	"./full_pt.js": [
		2885,
		885
	],
	"./full_ru.js": [
		8242,
		782
	],
	"./ru.js": [
		1770,
		770
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1230;
module.exports = webpackAsyncContext;